export const SET_ACTIVE_SORTING_COLUMN = "SET_ACTIVE_SORTING_COLUMNS";
export const SET_SORTING_DIRECTION = "SET_SORTING_DIRECTION";
export const SET_SELECTED_FILTERS = "SET_SELECTED_FILTERS";
export const SET_LOCAL_SYNC_TOGGLE = "SET_LOCAL_SYNC_TOGGLE";
